export const defaultSearchParams = {
    id: '',
    title: '',
    objective_type: '',
    year_id: '',
    active: '',
};

export const defaultTableParams = { per_page: 25, page: 0, totalCount: 0 };
